export { default } from "./FocusTrap.js";